import { all, fork } from '@redux-saga/core/effects'
import { StatsSaga } from './saga/StatsSaga'
import { NetworkSaga } from './saga/NetworkSaga'

export function* rootSagas() {
  yield all([
    fork(StatsSaga),
    fork(NetworkSaga),
  ])
}
